module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAApCAYAAADXsRIHAAAAxUlEQVR4Ae2TgQkCMQxFbwRHKbTamAA4ghu4SjfQDXQT3cDbwBHODbTRAhyh0SoIeCk8AImP3/5L99PjF8u1B9wHoGPmNiLi+fF7pK0H2lQlbo4uSy5CUMFHvNbTRBpUgQBPMpFzs1YR44EOQhYAU6OogEleMVL/iYyfRsjeeejMLgCsnmDiK3JhzTLxJ+3oqajvWs7r+k3GA2WJC2oBQ5kRcMtKkjY42J/L+GP+ViZb5mUdoycQ8xluctrrZDKTmcxkJrsDrvCsyMIz3D4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/partner-facebook.png
// module id = 323
// module chunks = 0